<template>
    <div class='process-indicator'>
        <ul class=''>
            <li v-bind:class='{selected:this.$store.state.processIndicator.step1}'>
                <i class="step1"></i><span>약관동의</span>
            </li>

            <li v-bind:class='{selected:this.$store.state.processIndicator.step2}'>
                <i class="step2"></i><span>신청서작성</span>
            </li>

            <li v-bind:class='{selected:this.$store.state.processIndicator.step4}'>
                <i class="step4"></i><span>가입신청 완료</span>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'ProgressIndicator',
}
</script>

<style scoped>

</style>
